import React, { useContext, useEffect } from "react";
import { AuthContext } from "../contexts/AuthProvider";
import { useNavigate } from "react-router-dom";

import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore"
import "../styling/Auth.css"

import sign_up_button from "../images/sign_in_with_button.png"

const Auth = () => {
    const db = getFirestore();
    const { user, signInWithGoogle } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSignIn = async() => {
        try {
            const userCredential = await signInWithGoogle();
            const user = userCredential;

            // Create user document if doesn't exist and create document in user_progress collection
            const userRef = doc(db, "users", user.uid)
            const userSnap = await getDoc(userRef)
            

            if (!userSnap.exists()) {
                await setDoc(userRef, {
                    name: user.displayName,
                    email: user.email
                })

                const userProgressRef = doc(db, "user_progress", user.uid)

                await setDoc(userProgressRef, {
                    accounting: {
                        "balance sheet": {
                            amountCompleted: 0,
                            correctQuestions: [],
                            incorrectQuestions: []
                        },
                        "income statement": {
                            amountCompleted: 0,
                            correctQuestions: [],
                            incorrectQuestions: []
                        },
                        "cash flow statement": {
                            amountCompleted: 0,
                            correctQuestions: [],
                            incorrectQuestions: []
                        },

                    },
                    questionsCompleted: 0,
                    questionsCorrect: 0
                })
            }
            
        } catch (error) {
            console.error("Error during sign in or mutation:", error);
        }
    };

    useEffect(() => {
        if (user) {
            navigate("/dashboard");
        }
    }, [user, navigate]);

    return (
        <div className="auth">
            <h2 className="auth__title">Sign Up to Aptix</h2>
            <img src={sign_up_button} onClick={handleSignIn} className="auth__sign-up-button"/>
        </div>
    );
};

export default Auth;